import React, { useState, useCallback, useMemo } from "react";
import Skeleton from "react-loading-skeleton";
import Tabs from "components/common/Tabs";
import { useFetchData } from "hooks/apiHooks";
import ApiError from "components/common/ApiError";
import { Card } from "reactstrap";
import SchedulerComponent from "components/Scheduler/SchedulerComponent";
import { transformEmailToEvent, transformInteractionToEvent, transformTodoToEvent } from "./eventTransformers";
import { useUserOptions } from "hooks/useUserOptions";
import { useList } from "hooks/useList";
import { OBJ } from "constants";


const LOCAL_STORAGE_KEY = 'todos_filter_tabs_kanban';


function TodoCalendarFrame({ list, filter, setSelectedItem, context }) {
    const { tabItems, isLoading, error, refetch} = useUserOptions()
    const [selectedTab, setSelectedTab] = useState(() => parseInt(localStorage.getItem(LOCAL_STORAGE_KEY)) || 0);

    const emailList = useList( filter, OBJ.EMAILS, null, false, {responsible_user_id: selectedTab}, 100);
    const todoList = useList( filter, OBJ.TODOS, null, false, {responsible_user_id: selectedTab}, 100);
    const interactionList = useList( filter, OBJ.INTERTACTION, null, false, {responsible_user_id: selectedTab}, 100);

    //console.log(todoList)
    const handleTabClick = useCallback((tab) => {
        setSelectedTab(tab);
        todoList.handleFilters({responsible_user_id: tab})
        emailList.handleFilters({responsible_user_id: tab})
        interactionList.handleFilters({responsible_user_id: tab})
        localStorage.setItem(LOCAL_STORAGE_KEY, tab);
    }, []);

    if (error) {return <ApiError retryFetch={refetch} errorMessage={error.message} />;}
    if (isLoading) {return (<Card><Skeleton height={40} count={1} /><Skeleton height={120} count={6} /></Card>);}

    const allEvents = [
        ...emailList.list?.items.map(transformEmailToEvent) || [],
        ...todoList.list?.items.map(transformTodoToEvent) || [],
        ...interactionList.list?.items.map(transformInteractionToEvent) || []
    ];

    return (
        <Card>
            <Tabs 
                items={tabItems} 
                activeTab={selectedTab} 
                handleTabClick={handleTabClick}
            />
            <SchedulerComponent data={allEvents}/>
        </Card>
    );
}

export default TodoCalendarFrame;